import React, { useState, useEffect } from "react";
import { CircularProgress, Checkbox, FormControlLabel } from "@material-ui/core";
import { Delete, Update, CloudDownload, Add } from "@material-ui/icons";
import { useSelector, useDispatch } from "react-redux";
import {
  massUpdate,
  getListView,
} from "../../../../store/actions/module.actions";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { IconButton } from '@material-ui/core';
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Badge from '@material-ui/core/Badge';

import { getNotifications } from "../../../../store/actions/dashboard.actions"
import { MassUpdateModal, AddToTargetListModal } from "./components";

import { pathOr } from "ramda";
import { toast } from "react-toastify";

import useStyles from "./styles";
import { Alert } from "../../../";

const CustomToolbarSelect = ({
  selectAll,
  handleSelectAllChange,
  selectedRows,
  displayData,
  setSelectedRows,
  selectedRecord,
  selectedRecordLength,
  setSelectedRecords,
  setSelectedRecordIndexes,
  setselectedRecordLength,
  setSelectAll,
  ACLAccess
}) => {
  const [massUpdateModalVisible, setMassUpdateModalVisible] = useState(false);
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [addToTargetModalVisible, setAddToTargetModalVisible] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [alertInfo, setAlertInfo] = useState({
    title: "",
    msg: "",
    visible: false,
    action: "",
  });
  const [loading, setLoading] = useState(false);
  const styles = useStyles();
  const { selectedModule, listViewTabData } = useSelector(
    (state) => state.modules,
  );
  const where = pathOr("", ['data', 'templateMeta', 'where'], listViewTabData[selectedModule]);
  const userData = pathOr(
    undefined,
    ["data", "attributes"],
    useSelector((state) => state.config.currentUserData),
  );
  const dispatch = useDispatch();
  // useEffect(() => {
  //   console.log("alert changed", alertInfo);

  // }, [alertInfo]);


  // const getSelectedRecordIds = () => {
  //   const selectedModuleRecords = pathOr(
  //     [],
  //     ["data", "templateMeta", "data"],
  //     listViewTabData[selectedModule],
  //   );
  //   return selectedRows.data.map(
  //     (record) => selectedModuleRecords[record.dataIndex].id,
  //   );
  // };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const buildPayloadForMassUpdate = (action, type, id, attributes = [], prospect_list = "") => ({
    action,
    data: {
      type,
      id,
      attributes,
      prospect_list
    },
  });

  const deleteRecords = async () => {
    try {
      setLoading(true);
      let recordsToDelete = selectAll ? ['All', where] : selectedRecord;   //getSelectedRecordIds();
      const payload = buildPayloadForMassUpdate(
        "delete",
        selectedModule,
        recordsToDelete,
      );
      let res = await massUpdate(payload);
      if (res.ok) {
        setLoading(false);
        setAlertInfo((prev) => ({ ...prev, visible: false }));
        toast("Records deleted successfully!");
        // setSelectAll(false)
        setselectedRecordLength(0)
        setSelectedRecords([])
        setSelectedRecordIndexes([])
        dispatch(getListView(selectedModule, 0));

      } else {
        setAlertInfo((prev) => ({ ...prev, visible: false }));
        toast(res.data.errors.detail);

      }
    } catch (e) {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast("something went wrong! please try again.");
    }
  };

  const updateRecords = async (fieldsToUpdate) => {
    try {
      setLoading(true);
      let selectedRecordsIds = selectAll ? ['All', where] : selectedRecord;    //getSelectedRecordIds();
      const payload = buildPayloadForMassUpdate(
        "update",
        selectedModule,
        selectedRecordsIds,
        fieldsToUpdate,
      );
      //console.log("maaaaaaaaaaasss update before",payload);
      let parent_name = pathOr(null,["data","attributes","parent_name"],payload);
      if(parent_name){
        delete payload.data.attributes.parent_name;
        payload.data.attributes = {...payload.data.attributes, ...parent_name};
      }
      ///console.log("maaaaaaaaaaasss update after",payload);
      let res = await massUpdate(payload);
      if (res.ok) {
        setLoading(false);
        toast("Records updated successfully!");
        dispatch(getListView(selectedModule, 0));
        // setSelectAll(false)
        setselectedRecordLength(0)
        setSelectedRecords([])
        setSelectedRecordIndexes([])

      } else {
        setAlertInfo((prev) => ({ ...prev, visible: false }));
        toast(res.data.errors.detail);

      }
    } catch (e) {
      toast("something went wrong! please try again.");
    }
  };

  const addIdToTargetList = async (propspectListId) => {
    try {
      setLoading(true);
      let recordsToBeAddedIds = selectAll ? ['All', where] : selectedRecord; //getSelectedRecordIds();
      const payload = buildPayloadForMassUpdate(
        "addToTargetList",
        selectedModule,
        recordsToBeAddedIds,
        [],
        propspectListId
      );
      let res = await massUpdate(payload);
      if (res.ok) {
        setLoading(false);
        setAlertInfo((prev) => ({ ...prev, visible: false }));
        toast("added to target list successfully!");
        dispatch(getListView(selectedModule, 0));
        // setSelectAll(false)
        setselectedRecordLength(0)
        setSelectedRecords([])
        setSelectedRecordIndexes([])

      } else {
        setAlertInfo((prev) => ({ ...prev, visible: false }));
        toast(res.data.errors.detail);

      }
    } catch (e) {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast("something went wrong! please try again.");
    }
  }

  const recordsExport = async () => {
    try {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      let recordIdsToBeExported = selectAll ? ['All', where] : selectedRecord; //getSelectedRecordIds();
      const payload = buildPayloadForMassUpdate(
        "export",
        selectedModule,
        recordIdsToBeExported,
        [],
      );
      toast("exporting in progress...");
      let res = await massUpdate(payload);
      console.log("maaaaaaaaaaasss update")
      console.log(res)

      if (res.ok) {

        setLoading(false);
        dispatch(getNotifications(1, userData.id));
        toast("Records exported successfully, check notifications section for the download link.");
        // setSelectedRecords([])

        setselectedRecordLength(0)
        setSelectedRecords([])
        setSelectedRecordIndexes([])

      } else {

        toast(res.data.errors.detail);

      }
    } catch (e) {
      setAlertInfo((prev) => ({ ...prev, visible: false }));
      toast("something went wrong! please try again.");
    }
  }
  return (
    <div className={styles.container}>
      {/* <div style={{
        margin: "4px 0px"
      }}>{selectAll ?
        <FormControlLabel label="All rows(s) selected" /> : <FormControlLabel label={selectedRecordLength + " rows(s) selected "}
        />}</div> */}
      {massUpdateModalVisible && (
        <MassUpdateModal
          updateRecords={updateRecords}
          updateLoader={loading}
          modalVisible={massUpdateModalVisible}
          toggleModalVisibility={() =>
            setMassUpdateModalVisible(!massUpdateModalVisible)
          }
        />
      )}
      {addToTargetModalVisible && (
        <AddToTargetListModal
          modalVisible={addToTargetModalVisible}
          toggleModalVisibility={() =>
            setAddToTargetModalVisible(!addToTargetModalVisible)
          }
          addIdToTargetList={addIdToTargetList}
          selectedModule={selectedModule}
        />
      )}
      {(selectedModule === "Contacts" || selectedModule === "Accounts") && <span
        className={styles.optionWrapper}
        onClick={() => setAddToTargetModalVisible(!addToTargetModalVisible)}
      >
        <Add fontSize="small" style={{ marginRight: "3px" }} /> Add to targetlist
      </span>}
      {ACLAccess.export===1 &&
      <span
        className={styles.optionWrapper}
        onClick={() =>
          setAlertInfo((prev) => ({
            ...prev,
            title: "Export records",
            msg: "Are you sure you want to export selected records?",
            visible: true,
            action: recordsExport,
          }))
        }
      >
        <CloudDownload fontSize="small" style={{ marginRight: "5px" }} /> Export
      </span>
      }
      {ACLAccess.edit===1 &&
      <span
        className={styles.optionWrapper}
        onClick={() => selectAll || selectedRecord.length > 20 ? toast("You can not mass update more than 20 records! please try again.") : setMassUpdateModalVisible(!massUpdateModalVisible)}
      >
        <Update fontSize="small" style={{ marginRight: "3px" }} /> Mass update
      </span>
      }
      {ACLAccess.delete===1 &&
      <span
        className={styles.optionWrapper}
        onClick={() => selectAll || selectedRecord.length > 20 ? toast("You can not delete more than 20 records! please try again.") : setAlertInfo((prev) => ({
          ...prev,
          title: "Delete records",
          msg: "Are you sure you want to delete selected records?",
          visible: true,
          action: deleteRecords,
        }))
        }

      >
        <Delete fontSize="small" style={{ marginRight: "3px" }} /> Delete
      </span>
      }
      <span>
        <Badge badgeContent={selectedRecordLength} max={999} color="primary">
          <IconButton aria-label="settings" onClick={handleClick}>
            <MoreVertIcon />
          </IconButton>
        </Badge>
        <Menu
          id="openSelectAll"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem >
            {selectAll ?
              <FormControlLabel
                control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} name="selectAllOption" />}
                label="Deselect All"
              /> : <FormControlLabel
                control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} name="selectAllOption" />}
                label={"Select All"}
              />}
          </MenuItem>

        </Menu>
      </span>
      <Alert
        title={alertInfo.title}
        msg={alertInfo.msg}
        open={alertInfo.visible}
        agreeText={loading ? "Deleting... " : "Yes"}
        disagreeText={"No"}
        handleClose={() => setAlertInfo({ visible: false })}
        onAgree={() => alertInfo.action()}
        loading={loading}
      />
    </div >
  );
};

export default CustomToolbarSelect;
